<p-card header="Welcome to Mindconnect 2"
    styleClass="border-1 surface-border shadow-6 surface-card border-round-xl">
    <p class="mb-2">
        This system currently aids testers to capture test-related information of testees during testing sessions for the
        following tests:
    </p>
    <ul>
        <li>SSAIS-R</li>
    </ul>
</p-card>